import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { AddVisaService } from 'src/app/service/addVisaSerivce';

declare var $:any;
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
  providers:[AddVisaService]
})
export class ChangePasswordComponent implements OnInit {
  @ViewChild('chngpass') form;
  userpassworddata:any={};
  public passMatch:boolean;
  constructor(private _http: HttpClient, private _toastr: ToastrService, private _visaService:AddVisaService) { }

  ngOnInit() {   
  }

  checkPassword(event) {
    const password = this.userpassworddata.newPwd;
    const confirm_new_password = event.target.value;

    if (password !== undefined) {
      if (confirm_new_password !== password) {
        this.passMatch = true;
      } else {
        this.passMatch = false;
      }
    }
  }

  createChangepass=function() {     
    $("#changePwdBtn").prop('disabled', true);
     if(this.userpassworddata.oldPwd==undefined||this.userpassworddata.oldPwd==""||this.userpassworddata.oldPwd==null){
      this._toastr.error("Old Password Cant be empty!"); 
      $("#changePwdBtn").prop('disabled', false);     
      return false;
     }else  if(this.userpassworddata.newPwd!==this.userpassworddata.cnfrmPwd){
      
      this._toastr.error("New Password and Confirm password should be same."); 
      $("#changePwdBtn").prop('disabled', false);     
      return false;
    }
    else if(this.userpassworddata.oldPwd==this.userpassworddata.newPwd){
        this._toastr.error("Old and New Passowrd Can't be Same!");
        $("#changePwdBtn").prop('disabled', false);
        return false;
    }
    else{
      this._visaService._changePassword(this.userpassworddata.oldPwd,this.userpassworddata.newPwd)  
        // this._http.post('http://192.168.60.101:83/api/UserDetails/ChangeUserPassword?EmpCode='+this.userId+'&OldPass='+this.userpassworddata.oldPwd+'&NewPass='+this.userpassworddata.newPwd+'')
        .subscribe(
          (SuccesData:any) => { 
            debugger;
            $("#changePwdBtn").prop('disabled', false);
            //console.log(SuccesData);
            if(SuccesData.status = true){
              this.userpassworddata={};
              this.form.form.markAsPristine();
              this.form.form.markAsUntouched();
              this.form.form.updateValueAndValidity();
              this._toastr.success(SuccesData.messsage);
            //  this._toastr.success('Password changed Successfully');              
            }else{
              this._toastr.error(SuccesData.messsage);
            }
          },
        (error: HttpErrorResponse) => {
          $("#changePwdBtn").prop('disabled', false);
          this.userpassworddata={};          
          this.err = error;
          //console.error(error);
          this._toastr.error('Password Updation Failed!');
        });
      } 
   };
}
